import React, { useState } from "react";
import { Upload, X } from "lucide-react";
import { api, fileUrl } from "@/lib/apiClient";
import { toast } from "sonner";

// Uploads a public image, returns url via onChange
export function ImageUpload({ value, onChange, label = "Image", testId = "image-upload" }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file); fd.append("access", "public");
      const { data } = await api.post("/files/upload", fd);
      onChange(data.url);
    } catch { toast.error("Upload failed"); } finally { setBusy(false); }
  };
  const src = value ? (value.startsWith("http") ? value : fileUrl(value)) : null;
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <div className="flex items-center gap-3 mt-1">
        {src ? (
          <div className="relative">
            <img src={src} alt="" className="w-16 h-16 rounded-xl object-cover border border-border" />
            <button type="button" onClick={() => onChange(null)} className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-red-500 text-white flex items-center justify-center"><X className="w-3 h-3" /></button>
          </div>
        ) : null}
        <label className="border border-dashed border-border rounded-xl px-4 py-3 text-sm text-muted-foreground cursor-pointer hover:border-teal transition-colors" data-testid={testId}>
          <Upload className="w-4 h-4 inline mr-1.5" /> {busy ? "Uploading..." : "Upload"}
          <input type="file" accept="image/*" className="hidden" onChange={upload} />
        </label>
      </div>
    </div>
  );
}

// Uploads any file publicly, returns (url, filename) via onChange
export function FileUpload({ value, filename, onChange, label = "File", accept = "*/*", testId = "file-upload" }) {
  const [busy, setBusy] = useState(false);
  const upload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file); fd.append("access", "public");
      const { data } = await api.post("/files/upload", fd);
      onChange(data.url, data.filename);
    } catch { toast.error("Upload failed"); } finally { setBusy(false); }
  };
  return (
    <div>
      <label className="text-sm font-medium">{label}</label>
      <div className="flex items-center gap-3 mt-1 flex-wrap">
        {value ? <span className="text-xs text-teal truncate max-w-[200px]">{filename || "Uploaded"}</span> : null}
        <label className="border border-dashed border-border rounded-xl px-4 py-2.5 text-sm text-muted-foreground cursor-pointer hover:border-teal transition-colors" data-testid={testId}>
          <Upload className="w-4 h-4 inline mr-1.5" /> {busy ? "Uploading..." : "Upload"}
          <input type="file" accept={accept} className="hidden" onChange={upload} />
        </label>
        {value ? <button type="button" onClick={() => onChange(null, null)} className="text-xs text-red-500">Remove</button> : null}
      </div>
    </div>
  );
}
